module.exports = __webpack_public_path__ + "img/first-screen_content.a330e632.jpg";